var map = {
	"./number-1.svg": 770,
	"./number-2.svg": 771,
	"./number-3.svg": 772,
	"./number-4.svg": 773,
	"./number-5.svg": 774,
	"./number-6.svg": 775,
	"./number-7.svg": 776,
	"./number-8.svg": 777,
	"./number-9.svg": 778,
	"./number-shine-1.svg": 779,
	"./number-shine-2.svg": 780,
	"./number-shine-3.svg": 781,
	"./number-shine-4.svg": 782,
	"./number-shine-5.svg": 783,
	"./number-shine-6.svg": 784,
	"./number-shine-7.svg": 785,
	"./number-shine-8.svg": 786,
	"./number-shine-9.svg": 787
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 769;